import { createContext } from 'react';
import { IPolicyEditContext, IPolicyNewContext } from '../policy';

const PolicyContext = createContext<IPolicyEditContext | IPolicyNewContext>(null);

export const { Provider: PolicyProvider } = PolicyContext;
export default PolicyContext;
